/*@ngInject*/
const UIPercentFormatterDirective = function ($timeout) {

    let linkFunction = function ($scope, $elm, $attrs, ngModelController) {
        let isEnabled,
            addPercent,
            numberDomain;

        function run() {
            function handleFocus() {
                if (ngModelController.$modelValue) {
                    ngModelController.$viewValue = ngModelController.$modelValue.toString().replace('%', '');
                } else {
                    ngModelController.$viewValue = '';
                }
                ngModelController.$render();
            }

            function handleBlur() {
                let value;
                if (ngModelController.$modelValue && !isNaN(ngModelController.$modelValue)) {
                    if (numberDomain === 'int') {
                        value = parseInt(ngModelController.$modelValue, 10);
                    } else {
                        value = ngModelController.$modelValue;
                    }
                    if (addPercent) {
                        value = value + '%';
                    }
                    ngModelController.$viewValue = value;
                    ngModelController.$render();
                }
            }

            function handleKeydown(event) {
                /*
                 * Unlike Chrome and IE, Firefox passes control chars (e.g., delete, tab)
                 * to the keydown handler, and the handler must allow those chars
                 * in order for their functionality to work.
                 */
                if ((event.which >= 48 && event.which <= 57) /*[0-9]*/ ||
                    (event.which >= 43 && event.which <= 46) /*[+,-.]*/ ||
                    event.which === 37 /*'%'*/ ||
                    event.which < 32 /*control chars*/)
                {
                    // allow
                } else {
                    return event.preventDefault();
                }
            }

            $scope.$watch($attrs['ngModel'], function (newValue) {
                if (!$($elm).is(':focus') && newValue) {
                    handleBlur();
                }
            });

            $($elm).on('focus', handleFocus);
            $($elm).on('blur', handleBlur);
            $($elm).on('keypress', handleKeydown);

            $scope.$on('$destroy', function () {
                $($elm).off('focus', handleFocus);
                $($elm).off('blur', handleBlur);
                $($elm).off('keypress', handleKeydown);
            });
        }

        $timeout(function () {
            isEnabled = $elm.hasClass('ui-percent-formatter');

            if (isEnabled) {
                addPercent = ($elm.attr('ui-percent-add-percent') === 'true');
                numberDomain = $elm.attr('ui-number-domain');
                run();
            }
        }, 300);
    };

    return {
        restrict: 'A',
        require: 'ngModel',
        link: linkFunction
    };
};

angular.module('umCore')
    .directive('uiPercentFormatter', UIPercentFormatterDirective);
